<template>
  <div class="d-flex button-wrapper">
    <div :class="`open-${feedbackSlug}`">
      <button
        class="action-button button mr-1"
        id="btnOpen"
        :class="{'bg-blue': tagValues.open, 'bg-grey': !tagValues.open}"
        @click="selectHandler('open')"
        >
        <fai :icon="['fas', 'star']" />
      </button>
      <Tooltip
        :text="btnTooltips('open')"
        :target="`.open-${feedbackSlug}`"
        :show-delay="500"
        name="setOpen"
        custom-class="feedbackTagButtonsTooltip open"
      />
    </div>
    <div :class="`resolved-${feedbackSlug}`">
      <button 
        class="action-button button mr-1"
        id="btnResolved"
        :class="{'bg-blue': tagValues.resolved, 'bg-grey': !tagValues.resolved}"
        @click="selectHandler('resolved')"
        >
        <fai :icon="['fas', 'check']" />
      </button>
      <Tooltip
        :text="btnTooltips('resolved')"
        :target="`.resolved-${feedbackSlug}`"
        :show-delay="500"
        name="setOpen"
        custom-class="feedbackTagButtonsTooltip resolved"
      />
    </div>
    <div :class="`flagged-${feedbackSlug}`">
      <button 
        class="action-button button"
        id="btnFlagged"
        :class="{'bg-blue': tagValues.flagged, 'bg-grey': !tagValues.flagged}"
        @click="selectHandler('flagged')"
        >
        <fai :icon="['fas', 'flag']" />
      </button>
      <Tooltip
        :text="btnTooltips('flagged')"
        :target="`.flagged-${feedbackSlug}`"
        :show-delay="500"
        name="setOpen"
        custom-class="feedbackTagButtonsTooltip flagged"
      />
    </div>
  </div>
</template>

<script>
import { Tooltip } from "uiv";
import { feedbackAPI } from "../../../services/api/feedbackAPI"

export default {
  props: {
    feedbackSlug: [Boolean, String],
    feedbackTags: [Boolean, Array]
  },
  name: "FeedbackTagButtons",
  components: {
    Tooltip
  },
  data() {
    return {
      tagValues: {
        open: false,
        resolved: false,
        flagged: false
      }
    }
  },
  created() {
    this.setTags()
  },
  methods: {
    setTags: function() {
      const len = this.feedbackTags.length
      if(len == 0) return

      this.feedbackTags.forEach(item => {
        this.tagValues[item.tag_type] = true
      })
    },
    async selectHandler(type) {
      if(!this.feedbackSlug) return

      const setValue = !this.tagValues[type]
      const options = {
        params: {
          tagType: type,
          tagValue: setValue,
          slug: this.feedbackSlug
        }
      }

      const resp = await feedbackAPI.PUTFeedbackTags(options)

      // only store if the response comes back as 200
      if (resp['status'] == 200) this.tagValues[type] = setValue

      if (type == 'open' && this.tagValues['resolved']) {
        this.tagValues['resolved'] = false
      }

      if (type == 'resolved' && this.tagValues['open']) {
        this.tagValues['open'] = false
      }
    },
    btnTooltips(tagName) {
      if (this.tagValues[tagName]) {
        return `clear this item's ${tagName} tag`;
      }
      if (!this.tagValues[tagName])  {
        return `tag this item as ${tagName}`;
      }
    }
  }
};
</script>
